import React, {useContext, useEffect, useState} from "react";
import {Badge, Button, Col, Dropdown, Row, Tab, Tabs} from "react-bootstrap";
import Form from "react-bootstrap/esm/Form";
import moment from "moment";
import CustomDatePicker from "../../../base/components/forms/customDatePicker";
import RemoveLink from "./removeLink";
import {useFieldArray} from "react-hook-form";
import AirBookingTicketSegment from "./airBookingTicketSegment";
import FormHookInput from "./formHookInput";
import _ from "lodash";

import {TripItemCreateRoute} from "../../../routesConstants";
import numberFormat from "../../../../helpers/numberFormat";
import toast, { Toaster } from 'react-hot-toast';
import TicketTiedUps from "./ticketTiedUps";

const notify = () => toast.success('Билет скопирован!');


const AirBookingTicketForm = ({
                                index,
                                prefix,
                                ticket,
                                deleteTicket,
                                copyTicket,
                                formController,
                                copyTicketToCash
                              }) => {
  const {
    register,
    watch,
    control,
    setValue,
    getValues,
    formState: {errors}
  } = formController;
  const emptyToZero = (name) => (e) => {
    if (e.target.value === '') {
      e.target.value = 0
      setValue(name, 0)
    }
  }
  const segments = watch("segments", []);
  // const [airItems, setAirItems] = useContext(airContext)
  const segmentsControl = useFieldArray({
    control,
    name: `${prefix}.segments`,
    rules: {required: true},
    shouldUnregister: true,
    keyName: 'customId'
  });
  const emdsControl = useFieldArray({
    control,
    name: `${prefix}.emds`
  });

  const segmentTemplate = {
    segment: "",
    seat: ""
  };
  const emdTemplate = {
    emdNumber: "",
    fare: 0,
    taxes: 0,
    penalties: 0,
    airlineNumber: "",
    issuedDate: "",
    krs: 0,
    krsKayar:0,
    serviceComment: "",
    alternativeRoute:"",
    refund: false,
    isVoid: false,
    tableRecord:[]
  };
  const getVal = (name)=>{
    return +_.get(getValues(), `${prefix}.${name}`) ||0
  }
  const calculateTotal = () => {
    return (getVal('fare') + getVal('taxes') + getVal('penalties') + getVal('krsKayar')).toFixed(2);
  };

  const calculateBuyer = () => {
    return (
      getVal('fare') +
      getVal('taxes') +
      getVal('penalties') +
      getVal('krsBuyer') +
      getVal('krsKayar')
      // getVal('commissionBuyer')
    ).toFixed(2);
  };
  const calculateSeller = () => {
    return (
      getVal('fare') +
      getVal('taxes') +
      getVal('penalties') +
      getVal('krsSeller')
      // getVal('commissionSeller')
    ).toFixed(2);
  };

  const removeEmd = index => {
    emdsControl.remove(index);
  };

  const baseCopy = index =>{
    const ticket = _.get(formController.getValues(), `${prefix}.emds[${index}]`);
    const newTicket = structuredClone(ticket)
    delete newTicket._id
    return newTicket
  }
  const copyEmd = index =>{
    emdsControl.append(baseCopy(index))
  }
  const removeSegment = index => {
    segmentsControl.remove(index);
  };

  const copyEmdToCash = index =>{
    const newTicket = baseCopy(index)
    newTicket.type = 'EMD'
    localStorage.setItem('ticketCopy', JSON.stringify(newTicket))
    notify()
  }
  const importEMD = () =>{
    let copied = localStorage.getItem('ticketCopy')
    if(copied){
      const newItem = JSON.parse(copied)
      if (newItem.type === "TKT") {
        newItem.emdNumber = newItem.ticketNumber
        newItem.krs = newItem.krsBuyer + newItem.krsSeller + newItem.krsKayar

      }
      emdsControl.append(newItem)
      localStorage.removeItem('ticketCopy')
    }else{
      window.alert('В кэше нет скопированных билетов')
    }
  }

  useEffect(() => {
    console.log('all segments',getValues().segments, segmentsControl.fields)
    segmentsControl.fields.forEach((s,index)=>{
      const haveSeg = _.find(getValues().segments, {id: s.segment}) || _.find(getValues().segments, {tempId: s.segment})
      if(!haveSeg){
        segmentsControl.remove(index)
      }
    })
  }, [watch('segments')]);
  const getNeedInfo = (ticketNumber) =>{
    let sendingInfo = {}
    getValues().paxes.forEach((p,i)=>{
      const copyTicket = _.find(p.tickets, {ticketNumber})
      if(copyTicket){
        sendingInfo.paxes = [{...p, tickets: [{...copyTicket, refund: true}]}]
      }
    })
    Object.keys(getValues()).forEach(key=>{
      if(key !== "paxes"){
        sendingInfo[key] = getValues()[key]
      }
    })
    return sendingInfo
  }

  const createElem = () =>{
    localStorage.setItem('ticketForElement', ticket.id)
    window.open(TripItemCreateRoute + `?type=ticket`,'_blank')
  }
  return (
    <div >
      <Row className="align-items-center mb-3">
        <Col xs="2">
          <input
            defaultValue={ticket.id}
            type={"hidden"}
            {...register(`${prefix}.id`)}
          />
          <FormHookInput
            defaultValue={ticket.airlineCode}
            label={'Авиакомпания'}
            register={register(`${prefix}.airlineCode`, {
              required: true,
              maxLength: 3,
              minLength: 3
            })}
            errors={errors}
          />
        </Col>
        <Col xs="2">
          <FormHookInput
            defaultValue={ticket.ticketNumber}
            label={'Номер билета'}
            register={register(`${prefix}.ticketNumber`, {
              required: true,
            })}
            errors={errors}
          />
        </Col>
        <Col xs="2">
          <CustomDatePicker
            value={ticket.issuedDate}
            label={'Дата выписки'}
            name={`${prefix}.issuedDate`}
            rules={{required: true}}
            formController={formController}
            // showTimeSelect={true}
          />
        </Col>
        <Col xs="2">
          <FormHookInput
            defaultValue={ticket.officeId}
            label={'Код офиса'}
            register={register(`${prefix}.officeId`)}
            errors={errors}
          />
        </Col>

        <Col xs="4">
          <FormHookInput
            defaultValue={ticket.prevTicket}
            label={'Номер пред. билета'}
            placeholder={"000-123456789"}
            register={register(`${prefix}.prevTicket`, {
              pattern: /[0-9]{3}-[0-9]{10}/
            })}
            errors={errors}
          />
        </Col>
      </Row>
      <Row >
        <Col xs={8}>
          <Row className={'mb-3'}>
            <Col xs="3">
              <FormHookInput
                defaultValue={ticket.fare}
                label={'Тариф'}
                placeholder={"Тариф"}
                register={register(`${prefix}.fare`, {
                  required: true,
                  valueAsNumber: true,
                  onBlur: emptyToZero(`${prefix}.fare`)
                  })}
                type={"number"}
                step={"0.01"}
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col xs="3">
              <FormHookInput
                defaultValue={ticket.taxes}
                label={'Таксы'}
                placeholder={"Таксы"}
                register={register(`${prefix}.taxes`,
                  {required: true,
                  valueAsNumber: true,
                  onBlur: emptyToZero(`${prefix}.taxes`)})}
                type="number"
                step={"0.01"}
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col xs="3">
              <FormHookInput
                defaultValue={ticket.penalties}
                placeholder={"Штрафы"}
                label={'Штрафы'}
                type="number"
                step={"0.01"}
                register={register(`${prefix}.penalties`, {
                  required: true,
                  valueAsNumber: true,
                  onBlur: emptyToZero(`${prefix}.penalties`)})}
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col xs="3">
              <FormHookInput
                defaultValue={ticket.currency}
                label={'Валюта'}
                placeholder={"Валюта"}
                register={register(`${prefix}.currency`, {
                  required: true,
                  pattern: /[A-Z]{3}/
                })}
                onChange={e => {
                  e.target.value = ("" + e.target.value).toUpperCase();
                }}
                errors={errors}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <FormHookInput
                defaultValue={ticket.krsSeller}
                label={'КРС пост.'}
                register={register(`${prefix}.krsSeller`, {
                  required: true,
                  valueAsNumber: true,
                  onBlur: emptyToZero(`${prefix}.krsSeller`)})}
                placeholder={"КРС поставщика"}
                step={"0.01"}
                type="number"
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col xs={3}>
              <FormHookInput
                defaultValue={ticket.krsBuyer}
                label={'КРС клиента'}
                register={register(`${prefix}.krsBuyer`, {
                  required: true,
                  valueAsNumber: true,
                  onBlur: emptyToZero(`${prefix}.krsBuyer`)})}
                placeholder={"КРС клиента"}
                type="number"
                step={"0.01"}
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
            <Col xs={3}>
              <FormHookInput
                defaultValue={ticket.krsKayar}
                label={'КРС Kayar'}
                register={register(`${prefix}.krsKayar`,{
                  valueAsNumber: true,
                  onBlur: emptyToZero(`${prefix}.krsKayar`)})}
                placeholder={"КРС Kayar"}
                step={"0.01"}
                type="number"
                errors={errors}
                onWheel={(e) => e.target.blur()}
              />
            </Col>
          </Row>
          {!!ticket.originalTicket ?
            <b className={ticket.originalTicket.krsBuyer+ticket.originalTicket.krsKayar>20000 ?'text-danger':'text-secondary'}>
            КРС изначального билета {numberFormat(ticket.originalTicket.krsBuyer+ticket.originalTicket.krsKayar)}
              {ticket.originalTicket.krsKayar>0 ? `(${numberFormat(ticket.originalTicket.krsBuyer)} + ${ticket.originalTicket.krsKayar})`:''}
          </b> : ''}
          <Row className={"segmentContainer mt-3"}>
            <Col xs={12}>
              <FormHookInput
                defaultValue={ticket.serviceComment}
                label={'Коментарий для 1с'}
                register={register(`${prefix}.serviceComment`)}
              />
            </Col>
          </Row>
          {!!watch(`${prefix}.tiedUp`) && (
            <TicketTiedUps prefix={prefix} formController={formController}/>
          )}
        </Col>

        <Col xs={4}>
          <div className={'d-flex justify-content-between'}>
            <Form.Label>
              <input
                defaultChecked={ticket.refund}
                {...register(`${prefix}.refund`)}
                type={"checkbox"}
              />{" "}
              Возврат
            </Form.Label>
            <Form.Label>
              <input
                defaultChecked={ticket.tiedUp}
                {...register(`${prefix}.tiedUp`, {
                  onChange: (e) => {
                    if (!e.target.checked) setValue(`${prefix}.tiedUps`, [])
                  }
                })}
                type={"checkbox"}
              />{" "}
              Привязка
            </Form.Label>
            <Form.Label>
              <input
                defaultChecked={ticket.isVoid}
                {...register(`${prefix}.isVoid`,
                  {onChange:(e)=>{
                    if(e.target.checked){
                      setValue(`${prefix}.fare`, 0)
                      setValue(`${prefix}.taxes`, 0)
                      setValue(`${prefix}.penalties`, 0)
                      setValue(`${prefix}.krsBuyer`, 0)
                      setValue(`${prefix}.krsSeller`, 0)
                      setValue(`${prefix}.krsKayar`, 0)
                    }
                    }})}
                type={"checkbox"}
              />{" "}
              VOID
            </Form.Label>
          </div>
          <div>

            <div className={'link-info pointer'}
                 onClick={copyTicket}>
              Копировать билет
            </div>

            Итого: {calculateTotal()} {ticket.currency}
            <br/>
            Итого поставщик: {calculateSeller()} {ticket.currency} <br/>
            Итого покупатель: {calculateBuyer()} {ticket.currency} <br/>
            {ticket.id && !ticket.tripItem && <div className={'link-info pointer'}
                                                   onClick={createElem}>
              Создать элемент
            </div>}
            <div className={'d-flex justify-content-between align-items-center'}>
              <RemoveLink onClick={deleteTicket} title={"билет"}/>
              <Button size={'sm'} variant={'outline-secondary'} onClick={()=>{
                copyTicketToCash()
                notify()
              }}>
                <i className="fa fa-external-link" />
              </Button>
            </div>

          </div>
        </Col>
      </Row>

      <Row>
      <Col xs={12}>
          <Form.Label>
            Сегменты{" "}
            <Badge
              onClick={() => segmentsControl.append({...segmentTemplate})}
              variant="success"
            >
              <i className={"la la-plus"}/> Добавить сегмент
            </Badge>
            <Badge
              onClick={() => {
                getValues().segments.forEach(seg=>{
                  console.log(seg)
                  if(!_.find(segmentsControl.fields, {segment: seg.tempId})){
                    segmentsControl.append({segment:seg.tempId, seat:''})
                  }
                })
              }}
              variant="success"
              className={'ml-2'}
            >
              <i className={"la la-plus"}/> Добавить все сегменты
            </Badge>
          </Form.Label>
          {_.get(errors, `${prefix}.segments.root`) ? (
            <p className={"text-danger"}>Минимум 1 сегмент</p>
          ) : null}
          {segmentsControl.fields.map((ticketSegment, index) => {
            return (
              <AirBookingTicketSegment
                prefix={`${prefix}.segments[${index}]`}
                key={ticketSegment.customId}
                ticketSegment={ticketSegment}
                segments={segments}
                formController={formController}
                removeSegment={() => {
                  removeSegment(index);
                }}
              />
            );
          })}

        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div className={'d-flex justify-content-between align-items-center mb-2'}>
            <Form.Label className={'mb-0'}>
              Доп. сборы (EMD){" "}
              <Badge
                onClick={() => emdsControl.append({...emdTemplate})}
                variant="success"
              >
                <i className={"la la-plus"}/> Добавить EMD
              </Badge>
            </Form.Label>
            <Button size={'sm'} variant={'outline-secondary'} onClick={importEMD}>
              <i className="fa fa-download" aria-hidden="true"></i>
            </Button>
          </div>
          {emdsControl.fields.map((emd, index) => {
            return (
              <Row key={emd.id} >
                {index+1}.
                <Row
                  key={index}
                  className={"segmentContainer align-items-center"}
                >
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.airlineCode}
                      label={'Номер авиа'}
                      register={register(
                        `${prefix}.emds[${index}].airlineCode`,
                        {
                          required: true,
                          maxLength: 3,
                          minLength: 3
                        }
                      )}
                      // placeholder={"Авиакомпания"}
                      errors={errors}
                    />
                  </Col>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.emdNumber}
                      label={'Номер'}
                      register={register(`${prefix}.emds[${index}].emdNumber`, {
                        required: true,
                        pattern: /[0-9]{10}/
                      })}
                      // placeholder={"Номер"}
                      errors={errors}
                    />
                  </Col>
                  <Col xs={2}>
                    <CustomDatePicker
                      value={emd.issuedDate}
                      label={'Дата выписки'}
                      name={`${prefix}.emds[${index}].issuedDate`}
                      rules={{required: true}}
                      formController={formController}
                    />
                  </Col>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.fare}
                      label={'Тариф'}
                      register={register(`${prefix}.emds[${index}].fare`, {
                        required: true,
                        valueAsNumber: true,
                        onBlur: emptyToZero(`${prefix}.emds[${index}].fare`)
                      })}
                      type="number"
                      step={"0.01"}
                      errors={errors}
                      onWheel={(e) => e.target.blur()}
                    />
                  </Col>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.taxes}
                      label={'Таксы'}
                      register={register(`${prefix}.emds[${index}].taxes`, {
                        required: true,
                        valueAsNumber: true,
                        onBlur: emptyToZero(`${prefix}.emds[${index}].taxes`)
                      })}
                      type="number"
                      step={"0.01"}
                      errors={errors}
                      onWheel={(e) => e.target.blur()}
                    />
                  </Col>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.penalties}
                      label={'Штрафы'}
                      register={register(`${prefix}.emds[${index}].penalties`, {
                        required: true,
                        valueAsNumber: true,
                        onBlur: emptyToZero(`${prefix}.emds[${index}].penalties`)
                      })}
                      type="number"
                      step={"0.01"}
                      errors={errors}
                      onWheel={(e) => e.target.blur()}
                    />
                  </Col>
                </Row>
                <Row className={"segmentContainer align-items-center mb-0"} style={{marginLeft:1}}>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.krs}
                      label={'КРС'}
                      register={register(`${prefix}.emds[${index}].krs`, {
                        required: true,
                        valueAsNumber: true,
                        onBlur: emptyToZero(`${prefix}.emds[${index}].krs`)
                      })}
                      type="number"
                      step={"0.01"}
                      errors={errors}
                      onWheel={(e) => e.target.blur()}
                    />
                  </Col>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.krsKayar}
                      label={'КРС Kayar'}
                      register={register(`${prefix}.emds[${index}].krsKayar`,{
                        valueAsNumber: true,
                        onBlur: emptyToZero(`${prefix}.emds[${index}].krsKayar`)})}
                      placeholder={"КРС Kayar"}
                      step={"0.01"}
                      type="number"
                      errors={errors}
                      onWheel={(e) => e.target.blur()}
                    />
                  </Col>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.serviceComment}
                      label={'Ком. для 1с'}
                      register={register(`${prefix}.emds[${index}].serviceComment`)}
                    />
                  </Col>
                  <Col xs={2}>
                    <FormHookInput
                      defaultValue={emd.alternativeRoute}
                      label={'Альт. маршрут'}
                      register={register(`${prefix}.emds[${index}].alternativeRoute`)}
                    />
                  </Col>

                  <Col>
                    <Form.Label>
                      <input
                        defaultChecked={emd.refund}
                        {...register(`${prefix}.emds[${index}].refund`)}
                        type={"checkbox"}
                      />{" "}
                      Возврат
                    </Form.Label><br/>
                    <Form.Label>
                      <input
                        defaultChecked={emd.isVoid}
                        {...register(`${prefix}.emds[${index}].isVoid`,
                          {
                            onChange: (e) => {
                              if (e.target.checked) {
                                setValue(`${prefix}.emds[${index}].krs`, 0)
                                setValue(`${prefix}.emds[${index}].krsKayar`, 0)
                                setValue(`${prefix}.emds[${index}].penalties`, 0)
                                setValue(`${prefix}.emds[${index}].taxes`, 0)
                                setValue(`${prefix}.emds[${index}].fare`, 0)
                              }
                            }
                          })}
                        type={"checkbox"}
                      />{" "}
                      VOID
                    </Form.Label>

                  </Col>
                  <Col>
                    <RemoveLink
                      onClick={() => removeEmd(index)}
                      title={"EMD"}
                    />
                  </Col>
                  {/*<Col>*/}
                  {/*  <DropdownButton variant="outline-secondary" size="sm" title="Действия">*/}
                  {/*    <Dropdown.Item as="button" type={'button'} onClick={() => copyEmd(index)}>*/}
                  {/*      Копировать EMD*/}
                  {/*    </Dropdown.Item>*/}
                  {/*    <Dropdown.Item as="button" type={'button'} onClick={() => removeEmd(index)}>*/}
                  {/*      Удалить EMD*/}
                  {/*    </Dropdown.Item>*/}
                  {/*    <Dropdown.Item as="button" type={'button'} onClick={()=>removeEmdAsTicket(ticket.ticketNumber,emd, index)}>*/}
                  {/*      В новый инвойс как билет-возврат*/}
                  {/*    </Dropdown.Item>*/}
                  {/*  </DropdownButton>*/}
                  {/*</Col>*/}
                </Row>
                <div className={'d-flex justify-content-between align-items-center mb-2'}>
                  <div>
                  </div>
                  <div>
                    <div className={'d-flex justify-content-between align-items-center gap-3'}>
                      <div className={'link-info pointer'}
                           onClick={() => copyEmd(index)}>
                        Копировать EMD
                      </div>
                      <Button size={'sm'} variant={'outline-secondary'} onClick={() => copyEmdToCash(index)}>
                        <i className="fa fa-external-link"/>
                      </Button>

                    </div>
                  </div>
                </div>

              </Row>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};

const AirBookingTicketsForm = ({pax, index, prefix, formController}) => {
  const {
    control,
    getValues,
    watch,
    formState: {errors}
  } = formController;
  const ticketsControl = useFieldArray({
    control,
    name: `${prefix}.tickets`,
    rules: {required: true},
    shouldUnregister: true,
    keyName: "customId"
  });

  const ticketTemplate = {
    ticketNumber: "",
    airline: "",
    issuedDate: moment().startOf('day').format('DD.MM.YYYY'),
    officeId: "",
    currency: "KZT",
    fare: 0,
    taxes: 0,
    penalties: 0,
    // commissionBuyer: 0,
    // commissionSeller: 0,
    krsBuyer: 0,
    krsSeller: 0,
    krsKayar: 0,
    segments: [],
    emds: [],
    tableRecord:[],
    refund: false,
    isVoid: false,
    tiedUp: false,
    tiedUps: []
  };

  const [tabIndex, setTabIndex] = useState(null);
  useEffect(() => {
    if (!tabIndex && pax.tickets.length !== 0) {
      setTabIndex(`ticket0`);
    }
  }, [pax]);

  const ticketLength = watch(`${prefix}.tickets`, []);
  const tabOnClick = key => {
    if (key === "add") {
      const newTicket = {...ticketTemplate};
      ticketsControl.append(newTicket);
      setTabIndex(`ticket${ticketLength.length}`);
    } else {
      setTabIndex(key);
    }
  };


  const deleteTicket = index => {
    ticketsControl.remove(index);
    if (ticketLength.length - 1) {
      setTabIndex(`ticket${ticketLength.length - 2}`);
    }
  };

  const baseCopy = index =>{
    const ticket = _.get(formController.getValues(), `${prefix}.tickets[${index}]`);
    const newTicket = structuredClone(ticket)
    delete newTicket.id
    newTicket.emds = []
    newTicket.tiedUps = (newTicket.tiedUps || []).map(item => ({
      tiedUpIssuedBy: item.tiedUpIssuedBy || "",
      tiedUpComment: item.tiedUpComment || "",
      tiedUpPaid: false,
      tiedUpChecked: false
    }))
    return newTicket
  }
  const copyTicket = index =>{
    ticketsControl.append(baseCopy(index))
    setTabIndex(`ticket${ticketLength.length}`)
  }

  const copyTicketToCash = index =>{
    const newTicket = baseCopy(index)
    newTicket.type = 'TKT'
    localStorage.setItem('ticketCopy', JSON.stringify(newTicket))
  }

  const importTicket = () =>{
    let copied = localStorage.getItem('ticketCopy')
    if(copied){
      const newItem = JSON.parse(copied)
      if (newItem.type === "EMD") {
        newItem.ticketNumber = newItem.emdNumber
        newItem.krsBuyer = newItem.krs
        newItem.krsSeller = 0
        newItem.currency = "KZT"
        newItem.krsKayar = 0
      }
      ticketsControl.append(newItem)
      setTabIndex(`ticket${ticketLength.length}`)
      localStorage.removeItem('ticketCopy')
    }else{
      window.alert('В кэше нет скопированных билетов')
    }
  }
  return (
    <div style={{position:'relative'}}>
      <Toaster  position="bottom-center-center"
                toastOptions={{
                  duration:1000
                }}
                containerStyle={{ position: 'absolute',
                  bottom:100 }}/>
      <Row>
        <Col sm={12}>
          <Form.Group className={"formTitle"}>
            <div className={'d-flex gap-2 justify-content-between align-items-center mb-2'}>
              <h6 className={'mb-0'}>Билеты</h6>
              <Button size={'sm'} variant={'outline-secondary'} onClick={importTicket}>
                <i className="fa fa-download" aria-hidden="true"></i>
              </Button>
            </div>
            <Tabs
              id="controlled-tab-example"
              activeKey={tabIndex}
              onSelect={key => tabOnClick(key)}
            >
              {ticketsControl.fields.map((ticket, index) => {
                let name = "Билет " + (index + 1);
                if (ticket.ticketNumber) {
                  name = `${ticket.airlineCode}-${ticket.ticketNumber}`;
                }

                return (
                  <Tab
                    key={ticket.customId}
                    eventKey={`ticket${index}`}
                    tabClassName={
                      _.get(errors, `${prefix}.tickets[${index}]`)
                        ? "is-invalid"
                        : ""
                    }
                    title={name}
                  >
                    <AirBookingTicketForm
                      segments={[]}
                      index={index}
                      prefix={`${prefix}.tickets[${index}]`}
                      ticket={ticket}
                      deleteTicket={() => deleteTicket(index)}
                      copyTicket={()=>copyTicket(index)}
                      copyTicketToCash={()=>copyTicketToCash(index)}
                      key={index}
                      formController={formController}
                    />
                  </Tab>
                );
              })}
              <Tab eventKey={"add"} title={<i className={"la la-plus"}/>}/>
            </Tabs>
          </Form.Group>
        </Col>
      </Row>
      {(_.get(errors, `${prefix}.tickets`)?.root) ? (
        <p className={"text-danger"}>Минимум 1 билет</p>
      ) : null}
    </div>
  );
};

export default AirBookingTicketsForm;
